import { IImpactLibraryForm } from 'src/types'

export const initialFormState: IImpactLibraryForm = {
  name: '',
  description: '',
  un_sdg: [],
  types: [],
  image: {
    icon: null,
    file: null,
  },
  image_small: null,
  image_medium: null,
  period: null,
  url: null,
}
